import { Component, OnInit } from '@angular/core';
import { AcademyHighlightService } from 'src/app/services/academy-highlight.service';
import { SwiperComponent, SwiperDirective, SwiperConfigInterface, SwiperScrollbarInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { AcademyTopPlayersService } from 'src/app/services/academy-top-players.service';
import { AcademyCourtService } from 'src/app/services/academyCourt.service';
import { AcademybranchesService } from 'src/app/services/academybranches.service';
import { AcademycoachesService } from 'src/app/services/academycoaches.service';
import { Router } from '@angular/router';
import { AcademyprofileService } from 'src/app/services/academyprofile.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { AcademysliderService } from 'src/app/services/academyslider.service';
import { UserService } from 'src/app/services/user.service';
import { LazyLoadEvent } from "primeng/api";
@Component({
  selector: 'app-academies-profile',
  templateUrl: './academies-profile.component.html',
  styleUrls: ['./academies-profile.component.scss']
})
export class AcademiesProfileComponent implements OnInit {
  loading: boolean;
  highlightlist: any;
  playerlist: any;
  courtlist: any;
  branchlist: any;
  coachData: any;
  errorMessage = '';
  public disabled: boolean = false;
  item: any;

  public court_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    speed: 400,
    loop: false,
    autoplay: false,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false
    // },
    mousewheel: false,
    slidesPerView: 'auto',
    pagination: {
      el: ".swiper-pagination",
      clickable: true,



    },
    // navigation: false,
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }
  };



  public sliders_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    speed: 400,
    loop: false,
    autoplay: false,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false
    // },
    mousewheel: false,
    slidesPerView: 'auto',
    pagination: {
      el: ".swiper-pagination",
      clickable: true,



    },
    // navigation: false,
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      768: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      992: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      1200: {
        slidesPerView: 1,
        spaceBetween: 0
      }
    }
  };
  public courts_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    speed: 400,
    loop: false,
    autoplay: false,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false
    // },
    mousewheel: false,
    slidesPerView: 'auto',
    pagination: {
      el: ".swiper-pagination",
    },
    // navigation: false,
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 20
      }
    }
  };
  public slider_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    speed: 400,
    loop: false,
    autoplay: false,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false
    // },
    mousewheel: false,
    slidesPerView: 'auto',
    pagination: {
      el: ".swiper-pagination",
    },
    // navigation: false,
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 20
      }
    }
  };
  enduserid: any;
  imagedata: any;
  profileimage: any;
  loggedInAcademy;
  loggedInAcademyId;
  academyname: any;
  public academyDetails: any[] = [];
  public foundedYear;
  public sliderData: any[] = [];
  public sliderImages: any = [];
  public profileDetails;
  public kycDone;
  kycTotalRecords: any;
  kycData: any;
  rejectKycReasonView: boolean=false;
  viewReason: any;
  kycVerificationComplete: boolean=false;
  kycVerificationInComplete: any;
  constructor(private highlightservice: AcademyHighlightService,
    private playerservice: AcademyTopPlayersService,
    private academyCourtService: AcademyCourtService,
    private branchservice: AcademybranchesService,
    private coachservice: AcademycoachesService,
    private router: Router,
    private profileservice: AcademyprofileService,
    private tokenStorage: TokenStorageService,
    private sliderservice: AcademysliderService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.loggedInAcademy = this.tokenStorage.getUser();
    let currentUrl = '/';
    if (this.loggedInAcademy.access_token) {
      this.loggedInAcademyId = this.loggedInAcademy.userdata['academyId'];
      let roleName = this.loggedInAcademy.userdata.rolename;
      if (roleName == "academy") {
        this.getacademydetails(this.loggedInAcademyId);
      } else {
        this.router.navigate([currentUrl]);
      }
    } else {
      this.router.navigate([currentUrl]);
    }


  }
  async getBankDetails(userId) {
    let query = "?filterByDisable=false&filterByStatus=true&filterByuserId=" + userId +"&filterByPrimary=true";
    this.userService.getUserKycDetailsList(query).subscribe(
      res => {
        if(res.items.length>0){
        this.kycData=res.items[0]
        if(this.kycData.isPanVerified){
          this.kycDone=true;
        }else if(!this.kycData.isDocumentComplete  && this.kycData.isPanVerified){
          this.kycVerificationInComplete=true;
        }else if(!this.kycData.isPanVerified){
          this.kycDone=false;
        }
      }
      },
      err => {
      }
    );
  }
  getacademydetails(id) {
    this.profileservice.getacademydetails(id).subscribe(res => {
      this.item = res;
      this.academyDetails = res;
      this.enduserid = res.endUserId;
      this.academyname = res.name;
      this.foundedYear = res.foundedyear;
      this.profileimage = res.academypic;
      //this.imagedata = res.academypic;
      // if (this.imagedata != undefined) {
      //   this.imagedata.forEach((element) => {
      //     this.profileimage = element['image_src'];

      //   });
      // }
      this.loadhightlightlist();
      this.loadplayerlist();
      this.loadCourt();
      this.loadbranch();
      this.loadcoach();
      this.loadSlider();
      // this.getUserKycDetails(this.enduserid);
      this.getBankDetails(this.enduserid);
    })
  }
  // getUserKycDetails(userId) {
  //   this.userService.getUserDetails(userId).subscribe(
  //     data => {
  //       this.item = data;
  //       if (this.item) {
  //         this.profileDetails = this.item;
  //         var query = "?filterDisable=false&filterByuserId=" + userId;
  //         this.userService.getUserKycDetailsList(query).subscribe(
  //           (data) => {
  //             let totalRecords = data.items?.length;
  //             if (totalRecords < 1) {
  //               this.kycDone = false;
  //             } else {
  //               this.kycDone = true;
  //             }
  //           })
  //       }
  //     }, err => {
  //     });
  // }

  // loadUserKyc(event: LazyLoadEvent) {
  //   var query = "?filterDisable=false&filterByuserId=" + this.enduserid;
  //   this.userService.getUserKycDetailsList(query).subscribe(
  //     (data) => {
  //       this.loading = false;
  //       this.kycData = data.items;
  //       this.kycTotalRecords = data.totalCount;
  //     }
  //   );
  // }
  loadhightlightlist() {
    var query = "?filterByDisable=false&filterByAcademyId=" + this.loggedInAcademyId;
    this.highlightservice.getAcademyHighlightList(query).subscribe(
      data => {
        this.loading = false;
        this.highlightlist = data.data.items;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }

  loadplayerlist() {
    var query = "?filterByDisable=false&filterByAcademyId=" + this.loggedInAcademyId;
    this.playerservice.getAcademyTopPlayers(query).subscribe(
      data => {
        this.loading = false;
        this.playerlist = data.data.items;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }

  loadCourt() {
    var query = "?filterByDisable=false&filterByAcademyId=" + this.loggedInAcademyId;
    this.academyCourtService.getAcademyCourtList(query).subscribe(
      data => {
        this.loading = false;
        this.courtlist = data.data.items;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  loadbranch() {
    var query = "?filterByDisable=false&filterByAcademyId=" + this.loggedInAcademyId;
    this.branchservice.getAcademyBranches(query).subscribe(
      data => {
        this.loading = false;
        this.branchlist = data.data.items;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  loadcoach() {
    var query = "?filterByDisable=false&filterByAcademyId=" + this.loggedInAcademyId;
    this.coachservice.getAcademyCoaches(query).subscribe(data => {
      this.loading = false;
      this.coachData = data.data.items;
    },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  loadSlider() {
    var query = "?filterByDisable=false&filterByAcademyId=" + this.loggedInAcademyId;
    this.sliderservice.getAcademyslderList(query).subscribe(data => {
      this.loading = false;
      this.sliderData = data.data.items;
      if (this.sliderData.length > 0) {
        if (this.sliderData[0]['slider_image']) {
          this.sliderImages = this.sliderData[0]['slider_image'];
        }
      }
    },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  onclickedit() {
    this.router.navigate(['academies-profile/academies-profile-edit'])
  }

  public onIndexChange(index: number): void {
    //console.log('Swiper index: ', index);
  }

  public onSwiperEvent(event: string): void {
    //console.log('Swiper event: ', event);
  }

  public toggleKeyboardControl(): void {
    this.court_config.keyboard = !this.court_config.keyboard;
  }

  public toggleMouseWheelControl(): void {
    this.court_config.mousewheel = !this.court_config.mousewheel;
  }
  viewRejectReasonModal(data){
    this.rejectKycReasonView=true
  this.viewReason=data.rejectedReason
  }
}
